import { nw02p } from './helpers'

const formatTime = function (val, includeHours = false) {
  const time = Math.ceil(val)
  if (isNaN(time)) return ''
  const h = ~~(time / 3600)
  const m = ~~((time % 3600) / 60)
  const s = time % 60

  if (includeHours || h > 0) {
    return `${nw02p(h)}:${nw02p(m)}:${nw02p(s)}`
  }
  return `${nw02p(m)}:${nw02p(s)}`
}

export default formatTime
